import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss'],
    standalone: false
})
export class OverlayComponent {
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() showSpinner: boolean = true;
  @Input() overlayStyles: { [key: string]: any };
  constructor() {}
}
